import { useEffect, useState } from "react";
function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  if (!visible) return null;
  return (
    <button
      onClick={scrollToTop}
      aria-label="Torna all'inizio della pagina"
      className="back-to-top"
    >
      <i className="fas fa-arrow-up"></i>
    </button>
  );
}
export default BackToTop;
